import React, {useState, useContext} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import {FormattedMessage} from "react-intl";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import AutocompleteItemList from 'domain/components/merchandising/batchActions/AutocompleteItemList';
import EditIcon from '@mui/icons-material/Edit';
import {ProductDataContext} from "contexts/productDataContext";
import {getFilterLabel} from "domain/helpers/filterTranslations";
import useBatchActionLauncher from "domain/components/merchandising/batchActions/useBatchActionLauncher";
import {MENU_KEY_TO_API_TYPE} from "domain/components/merchandising/batchActions/batchActionTypes";
import LargeBatchWarning from "domain/components/merchandising/batchActions/LargeBatchWarning";

export default function UpdateGenderActionModal(props) {
    const {open, setOpen, setSelectAction, selectedProducts, selectAll, totalItems} = props;
    const batchSize = selectAll ? totalItems : selectedProducts.length;
    const { gendersLoaded, gendersFilters } = useContext(ProductDataContext);
    const [selectedGender, setSelectedGender] = useState([]);
    const launchBatchAction = useBatchActionLauncher(props.onActionLaunched);

    const handleAction = () => {
        handleClose();

        let body = props.buildBody();
        if (selectAll) {
            body = {
                ...body,
                batchAction: MENU_KEY_TO_API_TYPE.updateGender,
                batchActionValue: selectedGender.id,
            };
        } else {
            body = {
                batchAction: MENU_KEY_TO_API_TYPE.updateGender,
                batchActionValue: selectedGender.id,
                ids: selectedProducts
            };
        }

        launchBatchAction(body);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectAction('');
    };

    function buildOptions() {
        const options = gendersFilters.tabContent.items.map(option => ({
            id: option.id,
            label: getFilterLabel(option)
        }));
        return options;
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle
                id="alert-dialog-title"
                sx={{
                    marginX: 'auto'
                }}
            >
                <FormattedMessage id={"merchandising.batch_action.updateGender.modal.title"}/>
            </DialogTitle>
            <Divider />
            <DialogContent>
                {gendersLoaded &&
                    <AutocompleteItemList
                        options={buildOptions()}
                        sx={{ marginTop: '20px', width: '500px'}}
                        setSelectedValue={setSelectedGender}
                        inputLabel={"merchandising.batch_action.updateGender.modal.label"}
                    />
                }
                <LargeBatchWarning count={batchSize}/>
            </DialogContent>
            <DialogActions sx={{ padding: '15px'}}>
                <Button
                    onClick={handleClose}
                    startIcon={<ArrowBackIosIcon />}
                >
                    <FormattedMessage id={"merchandising.batch_action.modal.cancel"}/>
                </Button>
                <Button
                    onClick={handleAction}
                    variant="contained"
                    autoFocus
                    startIcon={<EditIcon/>}
                    sx={{
                        borderRadius: 28
                    }}
                >
                    <FormattedMessage id={"merchandising.batch_action.updateGender.modal.save"}/>
                </Button>
            </DialogActions>
        </Dialog>
    );
}
